// Anonymous per-browser id used to scope try-on history without login.
export function getDeviceId() {
  try {
    let id = localStorage.getItem("vi_device_id");
    if (!id) {
      id =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      localStorage.setItem("vi_device_id", id);
    }
    return id;
  } catch (e) {
    return "anon";
  }
}
